import './About.css';
// Import your photo - replace with your actual photo filename
import gitaPhoto from '../assets/gita-blueShirt.png';

function About() {
  return (
    <div className="about">
      <div className="container">
        <h1>About Me</h1>
        
        <section className="about-content">
          <div className="about-text">
            <h2>My Story</h2>
            <p>
              For over 30 years, I've been helping families, individuals, and investors achieve their real estate goals. Whether you're buying your dream home or selling your current property, my deep knowledge of the local neighborhoods and market trends ensures you get the very best results. Real estate isn't just about houses—it's about finding the right fit for your lifestyle and future.
            </p>
            
            <h2>My Mission</h2>
            <p>
              My mission is simple: to guide you every step of the way and provide all the tools, resources, and expertise you need to make your real estate journey smooth, successful, and stress-free.
            </p>
          </div>
          
          <div className="about-image">
            <img src={gitaPhoto} alt="Gita Kashani" className="profile-photo" />
          </div>
        </section>
        
      </div>
    </div>
  );
}

export default About;